import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import CrisisAlertIcon from '@mui/icons-material/CrisisAlert';
import SkipNextIcon from '@mui/icons-material/SkipNext';
import {
  Box,
  Button,
  CircularProgress,
  IconButton,
  Typography,
} from '@mui/material';
import { FunctionComponent } from 'react';

import { UserCard } from '../../../../../components/UserCard/UserCard';
import './TargetSwipe.css';
import { useTargetSwipe } from './useTargetSwipe';

interface TargetSwipeProps {
  eventId: string;
}

export const TargetSwipe: FunctionComponent<TargetSwipeProps> = ({
  eventId,
}) => {
  const {
    canSwipe,
    cards,
    swiped,
    swipe,
    childRefs,
    currentImageIndex,
    onNextImagePress,
    onPreviousImagePress,
    numberOfImages,
    hasSeenAllProfiles,
    currentIndex,
    isUsersLoading,
  } = useTargetSwipe(eventId);

  if (isUsersLoading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box
      sx={{
        position: 'relative',
      }}
    >
      <Box
        sx={{
          maxWidth: '100%',
          height: 500,
          position: 'relative',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          overflow: 'hidden',
        }}
      >
        <Box
          sx={{
            borderRadius: 4,
            height: '450px',
            width: '300px',
            bgcolor: 'background.paper',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Typography variant="h2">Fin</Typography>
        </Box>

        {[...cards].reverse().map((card, index, cards) => (
          <UserCard
            key={card.id}
            cardRef={childRefs[index]}
            onSwipe={(dir) => swiped(dir)}
            user={card}
            currentImageIndex={currentImageIndex}
            currentIndex={currentIndex}
            index={cards.length - index - 1}
          />
        ))}
      </Box>

      {hasSeenAllProfiles ? (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            p: 3,
          }}
        >
          <Typography>Vous avez vu tous le monde !</Typography>
        </Box>
      ) : numberOfImages > 0 ? (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: 2,
            p: 2,
          }}
        >
          <IconButton onClick={onPreviousImagePress}>
            <ArrowBackIosIcon />
          </IconButton>
          <Typography>
            Image {currentImageIndex + 1}/{numberOfImages}
          </Typography>
          <IconButton onClick={onNextImagePress}>
            <ArrowForwardIosIcon />
          </IconButton>
        </Box>
      ) : (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            p: 3,
          }}
        >
          <Typography>Aucune image</Typography>
        </Box>
      )}

      <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, p: 2 }}>
        <Button
          variant="outlined"
          disabled={!canSwipe}
          onClick={() => swipe('left')}
          startIcon={<SkipNextIcon />}
        >
          Passer
        </Button>
        <Button
          variant="contained"
          color="error"
          disabled={!canSwipe}
          onClick={() => swipe('right')}
          startIcon={<CrisisAlertIcon />}
        >
          Plier
        </Button>
      </Box>
    </Box>
  );
};
